import { ArrowUpRight } from "lucide-react";
import SectionHeading from "./SectionHeading";
import LangLink from "../shared/LangLink";
import { StaggerGroup, StaggerItem } from "../shared/Reveal";
import { GUIDE_PREVIEWS } from "../../data/homeContent";
import { useI18n } from "../../i18n";

export default function GuidePreviews() {
  const { t } = useI18n();
  return (
    <section className="bg-background py-20 md:py-28 lg:py-36" data-testid="guide-previews">
      <div className="container-psv">
        <SectionHeading eyebrow={GUIDE_PREVIEWS.eyebrow} heading={GUIDE_PREVIEWS.heading} />
        <StaggerGroup className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {GUIDE_PREVIEWS.cards.map((card, i) => (
            <StaggerItem key={card.to}>
              <LangLink
                to={card.to}
                aria-label={card.anchor}
                className="group flex flex-col h-full bg-surface border border-border rounded-lg p-8 hover:border-accent transition-colors duration-300"
                data-testid={`guide-card-${i}`}
              >
                <span className="font-serif text-6xl text-border group-hover:text-accent/40 transition-colors leading-none mb-6">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="font-serif text-2xl text-primary mb-4 leading-snug">{card.title}</h3>
                <p className="text-[15px] text-secondary-foreground leading-relaxed flex-1">{card.text}</p>
                <span className="mt-6 inline-flex items-center gap-1.5 text-accent font-medium text-sm font-sans group-hover:gap-2.5 transition-all">
                  {t("common.readGuide")} <ArrowUpRight className="w-4 h-4" />
                </span>
              </LangLink>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
}
